import { Container } from "@material-ui/core";

import { ComplaintTaskDocument } from "../../../task/task.model";
import { CommentDocument } from "../../../comment/comment.model";
import { Message } from "../../../Message";
import { ActivitySection } from "../../../comment/ActivitySection";
import { CustomerCommentList } from "../../../comment/CustomerCommentList";
import { BackButton } from "../../../components/BackButton";
import { Section } from "../../../components/section";
import { TitleHeader } from "../../../components/TitleHeader";
import { ContentSection } from "../../../layout/ContentSection";
import { RegistrationDetailCard } from "../../../finance/billing/pending-approval/RegistrationDetailCard";
import { InstructionCard } from "../../../workflow/InstructionCard";
import { ComplaintDetailCard } from "../../ComplaintDetailCard";
import { InvoiceDocument } from "../../../finance/billing/invoices/invoice.model";
import { AdministratorActionData } from "../../../workflow/administrator-action.hook";
import { GreenButton, VerticalButtons } from "../../../components/new-button";
import { AwaitCustomerResponseFormIds, useAwaitCustomerResponseDialog } from "./AwaitCustomerResponseDialog";
import { useCallback } from "react";
import { FormProps } from "../../../components/form-item/framework/react/FormProvider";
import { FormItem } from "../../../components/form-item/framework/core/form-item.model";
import { SingleChoiceFormItem, TextAreaFormItem } from "../../../components/form-item/client/components";

export interface AwaitCustomerResponseDetailPageProps {
    task: ComplaintTaskDocument;
    invoices: InvoiceDocument[];
    administratorAction: (data: AdministratorActionData | string) => void;
    comments: CommentDocument[];
    addComment: (comment: string) => void;
    goBack: () => void;
}

export const AwaitCustomerResponseDetailPage = (props: AwaitCustomerResponseDetailPageProps) => {
    const { task, invoices, administratorAction, comments, addComment } = props;

    const backButton = <BackButton onClick={props.goBack} />;

    const awaitCustomerResponseAdapter = useCallback<FormProps<FormItem>["onSubmit"]>((controller, formItem) => {
        const complaintStillRelevant = (controller.getItem(AwaitCustomerResponseFormIds.SingleChoiceStillRelevant, formItem) as SingleChoiceFormItem<any[]>).selectedChoiceIndex === 1;
        if ( !complaintStillRelevant ) {
            const reason = (controller.getItem(AwaitCustomerResponseFormIds.TextAreaCloseComplaintBecauseIrrelevantReason, formItem) as TextAreaFormItem).value;

            return administratorAction({
                action: "close complaint",
                complaintId: task.complaint.id,
                reason,
            });
        }

        const customerDidNotRespond = (controller.getItem(AwaitCustomerResponseFormIds.SingleChoiceCustomerResponse, formItem) as SingleChoiceFormItem<any[]>).selectedChoiceIndex === 2;
        if ( customerDidNotRespond ) {
            return alert("Should register customer did not respond"); // TODO
        }

        const customerAcceptedProposal = (controller.getItem(AwaitCustomerResponseFormIds.SingleChoiceCustomerResponse, formItem) as SingleChoiceFormItem<any[]>).selectedChoiceIndex === 0;
        if ( !customerAcceptedProposal ) {
            return alert("Should register customer rejected proposal"); // TODO
        }

        return alert("Should register customer accepted proposal"); // TODO
    }, [administratorAction, task]);
    const openAwaitCustomerResponseDialog = useAwaitCustomerResponseDialog(task, awaitCustomerResponseAdapter);

    return (
        <>
            <TitleHeader button={backButton}>Afvent svar fra kunde</TitleHeader>
            
            <ContentSection>
                <Container maxWidth="sm" disableGutters>

                    <Section>
                        {task.hasBeenPerformed ? <Message>Opgaven er allerede blevet udført</Message> : null}

                        <InstructionCard>
                            Registrer kundens svar på den tilbudte løsning.
                        </InstructionCard>

                        <ComplaintDetailCard complaint={task.complaint} administratorAction={administratorAction} />

                        {invoices.map(invoice => (
                            <RegistrationDetailCard key={invoice.id} invoice={invoice} gardenerName={task.gardenerName} />
                        ))}

                        <VerticalButtons>
                            <GreenButton onClick={openAwaitCustomerResponseDialog}>Besvar opgave</GreenButton>
                        </VerticalButtons>

                    </Section>

                    <ActivitySection onSave={addComment}>
                        <CustomerCommentList comments={comments} />
                    </ActivitySection>

                </Container>
            </ContentSection>
        </>
    );
};
